import { EChartsOption } from "echarts";

const chartToolbox: EChartsOption["toolbox"] = {
  iconStyle: {
    borderColor: "#ffffff",
  },
  emphasis: {
    iconStyle: {
      borderColor: "#ffffff",
    },
  },
  feature: {
    saveAsImage: {
      backgroundColor: "#7b00d4",
      pixelRatio: 2,
      // connectedBackgroundColor: "#1b1b1b",
      excludeComponents: ["toolbox"],
      name: "chart",
    },
  },
};

/**
 * -----------------------------
 * BAR CHART
 * -----------------------------
 */
export const getBarOption = (data: any): EChartsOption => {
  const categories = Array.isArray(data?.categories) ? data.categories : [];
  const values = Array.isArray(data?.values) ? data.values : [];
  const barWidth =
    categories.length > 18 ? 16 : categories.length > 10 ? 22 : 30;

  return {
    tooltip: {
      trigger: "axis",
    },

    toolbox: chartToolbox,

    grid: {
      left: "18%",
      right: "7%",
      top: "5%",
      bottom: "8%",
      containLabel: true,
    },

    xAxis: {
      type: "value",
      name: "Cases",
      nameGap: 18,
      nameTextStyle: {
        color: "#ffffff",
      },
      axisLabel: {
        color: "#ffffff",
      },
    },

    yAxis: {
      type: "category",
      data: categories,
      axisLabel: {
        color: "#ffffff",
        margin: 12,
      },
    },

    series: Array.isArray(data?.series)
      ? data.series.map((series: any) => ({
          ...series,
          type: "bar",
          barWidth,
          barMaxWidth: 30,
          barMinHeight: 2,
          barCategoryGap: "45%",
          label: {
            show: true,
            position: "right",
            color: "#ffffff",
            distance: 6,
          },
        }))
      : [
          {
            type: "bar",
            data: values,
            barWidth,
            barMaxWidth: 30,
            barMinHeight: 2,
            barCategoryGap: "45%",
            itemStyle: {
              color: "#d7a6ec",
            },
            label: {
              show: true,
              position: "right",
              color: "#ffffff",
              distance: 6,
            },
          },
        ],
  };
};

/**
 * -----------------------------
 * PIE CHART
 * -----------------------------
 */
export const getPieOption = (data: any): EChartsOption => ({
  tooltip: {
    trigger: "item",
  },

  legend: {
    orient: "horizontal",
    left: "bottom",
    textStyle: {
      color: "#ffffff",
    },
  },

  toolbox: chartToolbox,

  series: [
    {
      type: "pie",
      radius: "50%",
      data,
      label: {
        formatter: "{b}\n{c}",
        color: "#ffffff",
      },
    },
  ],
});

/**
 * -----------------------------
 * TREEMAP
 * -----------------------------
 */
export const getTreemapOption = (data: any): EChartsOption => ({
  tooltip: {
    trigger: "item",
  },

  toolbox: chartToolbox,

  series: [
    {
      type: "treemap",
      data,
      roam: true,
      breadcrumb: {
        show: true,
      },
      label: {
        show: true,
      },
    },
  ],
});

/**
 * -----------------------------
 * SUNBURST
 * -----------------------------
 */
export const getSunburstOption = (data: any): EChartsOption => ({
  // title: {
  //   text: "Cancer Classification",
  //   left: "center",
  //   top: 0,
  //   textStyle: {
  //     color: "#ffffff",
  //     fontSize: 16,
  //     fontWeight: "bold",
  //   },
  // },

  tooltip: {
    trigger: "item",
    formatter: "{b}: {c}",
  },

  toolbox: chartToolbox,

  series: [
    {
      type: "sunburst",
      radius: [0, "92%"],
      center: ["50%", "52%"],
      data: Array.isArray(data) ? data : [],
      sort: undefined,
      nodeClick: "rootToNode",
      itemStyle: {
        borderColor: "#ffffff",
        borderWidth: 2,
        borderRadius: 6,
      },

      emphasis: {
        focus: "ancestor",
      },

      label: {
        rotate: "radial",
        color: "#ffffff",
        minAngle: 8,
      },

      levels: [
        {},
        {
          r0: "0%",
          r: "33%",
          label: {
            rotate: 0,
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        {
          r0: "33%",
          r: "66%",
          label: {
            fontSize: 14,
          },
        },
        {
          r0: "66%",
          r: "92%",
          label: {
            fontSize: 12,
          },
        },
      ],
      selectedMode: "single",
      animationDurationUpdate: 500,
      universalTransition: true,
      blur: {
        itemStyle: {
          opacity: 0.35,
        },
      },
    },
  ],
});

/**
 * -----------------------------
 * CHART OPTION MAP
 * -----------------------------
 */

export const chartOptionMap = {
  bar: getBarOption,
  pie: getPieOption,
  treemap: getTreemapOption,
  sunburst: getSunburstOption,
};
